import {
  ConfirmIcon,
  FinanceIcon,
  FinishIcon,
  JobIcon,
  ReferencesIcon,
  ResidenceIcon,
  ValidationIcon,
} from '@components/atoms/icons/stepper';
import { IdCardIcon } from 'bda-web-ui-components';
import type { TFunction } from 'i18next';
import type { ReactElement, SVGProps } from 'react';

export interface StepDefinition {
  id: string;
  text: string;
  icon: ReactElement<SVGProps<SVGSVGElement>>;
}

export const getStepsList = (t: TFunction): StepDefinition[] => [
  {
    id: 'step1',
    text: t('stepper.steps.step1'),
    icon: <ValidationIcon className="baui:w-4 baui:h-4" />,
  },
  {
    id: 'step2',
    text: t('stepper.steps.step2'),
    icon: <IdCardIcon className="baui:w-4 baui:h-4" />,
  },
  {
    id: 'step3',
    text: t('stepper.steps.step3'),
    icon: <ResidenceIcon className="baui:w-4 baui:h-4" />,
  },
  {
    id: 'step4',
    text: t('stepper.steps.step4'),
    icon: <FinanceIcon className="baui:w-4 baui:h-4" />,
  },
  {
    id: 'step5',
    text: t('stepper.steps.step5'),
    icon: <JobIcon className="baui:w-4 baui:h-4" />,
  },
  {
    id: 'step6',
    text: t('stepper.steps.step6'),
    icon: <ReferencesIcon className="baui:w-4 baui:h-4" />,
  },
  {
    id: 'step7',
    text: t('stepper.steps.step7'),
    icon: <ConfirmIcon className="baui:w-4 baui:h-4" />,
  },
  {
    id: 'step8',
    text: t('stepper.steps.step8'),
    icon: <FinishIcon className="baui:w-4 baui:h-4" />,
  },
];
